module.exports = __webpack_public_path__ + "static/media/rubric-mobile.34143667.jpg";